import { CommonModule, DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MsalGuard, MsalInterceptor, MsalModule, MsalRedirectComponent } from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { AzureAdB2C } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AdminModule } from './features/admin/admin.module';
import { FeaturesModule } from './features/features.module';
import { PageLoaderComponent } from './shared/components/page-loader/page-loader.component';
import { HttpErrorInterceptor } from './shared/interceptors/http-error.interceptor';
import { PageLoaderInterceptor } from './shared/interceptors/page-loader.interceptor';
import { JwtAuthInterceptor } from './shared/interceptors/jwt-auth.interceptor';
import { MsalSkipInterceptor } from './shared/interceptors/msal-skip.interceptor';
import { GlobalErrorHandler } from './shared/services/global-error-handler.service';
import { SharedModule } from './shared/shared.module';

@NgModule({ declarations: [AppComponent, PageLoaderComponent],
    bootstrap: [AppComponent, MsalRedirectComponent], imports: [AppRoutingModule,
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        NgbModule,
        FeaturesModule,
        SharedModule,
        AdminModule,
        MsalModule.forRoot(new PublicClientApplication({
            auth: {
                clientId: AzureAdB2C.clientId,
                redirectUri: AzureAdB2C.redirectUri,
                authority: AzureAdB2C.authorty,
            },
            cache: {
                cacheLocation: AzureAdB2C.cacheLocation,
            },
        }), {
            interactionType: InteractionType.Redirect,
            authRequest: {
                scopes: AzureAdB2C.scope,
            },
        }, {
            interactionType: InteractionType.Redirect,
            protectedResourceMap: AzureAdB2C.protectedResourceMap,
            // The map's keys are path prefixes (e.g. `${baseUrl}user` covers `${baseUrl}user/...`), which needs non-strict matching
            strictMatching: false,
        }),
    ], providers: [
        provideCharts(withDefaultRegisterables()),
        {
            provide: ErrorHandler, useClass: GlobalErrorHandler,
        },
        {
            provide: DATE_PIPE_DEFAULT_OPTIONS,
            useValue: 'UTC',
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JwtAuthInterceptor,
            multi: true,
        },
        // MSAL Skip Interceptor (Runs after JWT Interceptor)
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalSkipInterceptor,
            multi: true,
        },
        // {
        //   provide: HTTP_INTERCEPTORS,
        //   useClass: MsalInterceptor,
        //   multi: true,
        // },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: PageLoaderInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true,
        },
        MsalGuard,
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
    ] })
export class AppModule { }
